import React, { useContext, useEffect, useState } from 'react'
import theme from '@ifca-root/react-component/src/assets/theme'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ExcelInput } from '@ifca-root/react-component/src/components/Input/ExcelInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2'
import { AppBar, List, ListItem, ListItemText, Tab, Tabs, useMediaQuery } from '@material-ui/core'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  useCreateMenuItemWithExcelMutation,
//   useCreateCompanyImportMutation,
//   useGetCheckingValidationCompanyQuery,
  useGetCheckingValidationMenuItemQuery,
  useGetCheckingValidationQuery,
  useGetOutletQuery
} from 'generated/graphql'
import { SystemMsgs } from '../../../../helpers/SystemMsg'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import AppContext from 'containers/App/Store/AppContext'
import { normalize } from 'path'

export const MenuitemExcelValidation = (props: any) => {
  const { outletID } = useParams<any>();
  const { mode } = props
  let location = useLocation()
  const passedData: any = location?.state
  const excelData = passedData.excelData
  const fileName = passedData.fileTitle
  const { globalState }: any = useContext(AppContext as any);
  let history = useHistory()
  const { CompanyID, BankAccountID }: any = useParams()
  const { accType }: any = useParams()
  let user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [validatedData, setValidatedData] = useState<any>({
    ErrorData: [],
    ValidData: [],
  })
  const [openDialog, setOpenDialog] = useState(false)
  const [errorNumberingStructure, setErrorNumberingStructure] = useState(false)
  const [sheetCategory,setSheetCategory]= useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [validatedSheets,setValidatedSheets] = useState([]);
//   const {
//     loading: CheckingValidationMenuItemLoading,
//     error: getCheckingValidationMenuItemError,
//     data: { getCheckingValidationMenuItem } = {
//       getCheckingValidationMenuItem: [],
//     },
//   } = useGetCheckingValidationMenuItemQuery({
//     fetchPolicy: 'network-only',
//     variables: {
//       MenuItemImportInput: passedData.excelData,
//       outletID: outletID
//     },
//     onCompleted: ({ getCheckingValidationMenuItem }) => {
//       let ErrorData: any = []
//       let ValidData: any = []
//  console.log("getCheckingValidationMenuItem",getCheckingValidationMenuItem);
 
//       getCheckingValidationMenuItem?.map(x => {
//         if (x['ErrorList']?.length > 0)
//           ErrorData.push({
//             name: x['name']?.trim(),
//             nativeName: x['nativeName']?.trim(),
//             kitchenName: x['kitchenName']?.trim(),
//             description: x['description']?.trim(),
//             major: x['major']?.trim(),
//             family: x['family']?.trim(),
//             kitchenPrinter: x['kitchenPrinter']?.trim(),
//             taxschemes: x['taxschemes']?.trim(),
//             uom: x['uom']?.trim(),
//             defaultQuantity: parseFloat(x['defaultQuantity']),
//             isOpenItem: x['isOpenItem'].trim(),
//             isOpenPrice: x['isOpenPrice'].trim(),
//             isChefRecommended: x['isChefRecommended'].trim(),
//             isQuantityControlled: x['isQuantityControlled'].trim(),
//             isDiscountable: x['isDiscountable'].trim(),
//             isByWeight: x['isByWeight'].trim(),
//             standardCost: parseFloat(x['standardCost']),
//             isPerforated: x['isPerforated'].trim(),
//             perforatedQuantity:parseFloat(x['perforatedQuantity']),
//             ErrorList: x['ErrorList'],
//           })
//         else
//           ValidData.push({
//             name: x['name']?.trim(),
//             nativeName: x['nativeName']?.trim(),
//             kitchenName: x['kitchenName']?.trim(),
//             description: x['description']?.trim(),
//             major: x['major']?.trim(),
//             family: x['family']?.trim(),
//             kitchenPrinter: x['kitchenPrinter']?.trim(),
//             taxschemes: x['taxschemes']?.trim(),
//             uom: x['uom']?.trim(),
//             defaultQuantity: Number(x['defaultQuantity']),
//             isOpenItem: x['isOpenItem']?.trim(),
//             isOpenPrice: x['isOpenPrice']?.trim(),
//             isChefRecommended: x['isChefRecommended']?.trim(),
//             isQuantityControlled: x['isQuantityControlled']?.trim(),
//             isDiscountable: x['isDiscountable']?.trim(),
//             isByWeight: x['isByWeight']?.trim(),
//             standardCost: Number(x['standardCost']),
//             isPerforated: x['isPerforated']?.trim(),
//             perforatedQuantity:Number(x['perforatedQuantity']),
//             ErrorList: x['ErrorList'],
//           })
//       })

//       setValidatedData({ ErrorData: ErrorData, ValidData: ValidData })
//     },
//   })
//  console.log("Passed data:", passedData.excelData);

  const {
    called: ouletCalled,
    loading: outletLoading,
    error: outletError,
    data: { getOutlet } = { getOutlet: [] },
  } = useGetOutletQuery({
    fetchPolicy: 'network-only',
    variables: { ID: outletID },
  });

    const outletArray: any[] = getOutlet;
useEffect(()=>{
  // console.log("Updated sheetCategory:",sheetCategory);
  if(!validatedSheets.length){
    return
  }
  const selectsheet = validatedSheets[selectedTab];

  let ErrorData = [];
  let ValidData = [];

  selectsheet.rows.map(row=>{
    if (row.ErrorList?.length>0) {
      ErrorData.push(row);
    }else{
      ValidData.push(row);
    }
  })

  setValidatedData({ErrorData,ValidData});
},[selectedTab,validatedSheets]);
  const {loading:GetCheckingValidationloading,
    error: GetCheckingValidationError,
    data: { getCheckingValidation} = {
      getCheckingValidation: [],
    },
  }= useGetCheckingValidationQuery({
    fetchPolicy:'network-only',
    variables:{
      sheets:[
        {
          excelData:passedData.excelData,
        }
      ] , 
      outletID
    },
    onCompleted:({getCheckingValidation })=>{
      console.log("passeddata",passedData.excelData);
      console.log("getCheckingValidation",getCheckingValidation);
      	const normalize = name => name?.toLowerCase().replace(/\s+/g, "").trim();
      // const menuSheet = getCheckingValidation.find(
      //   s=> s.sheetName.trim().toLowerCase()=== "menuitemlist"
      // );
      const findsheet = (data,name)=>{
        if(!data || !data.length) return null;


        const group = data[0];
        
        
         const lowerName = normalize(name);
         console.log("data",data,"group",group.menuitemlist);
        for(const key of Object.keys(group)){
          const sheetArray = group[key];
          console.log('sheetArray',sheetArray);
          

          if(!Array.isArray(sheetArray)){
            continue;
          }
          console.log("Checking Key:",key,"array:",sheetArray);
          
          const foundSheet = sheetArray.find(s=>normalize(s.sheetName) === lowerName);
          if (foundSheet) {
            return foundSheet;
          }
        };

        console.warn(`Sheet ${name} not found in group`,group);
        return null;
      };
      // const menuSheet = getCheckingValidation[0].menuitemlist[0];
      const menuSheet = findsheet(getCheckingValidation,'MenuItemList');
      const testingSheet = findsheet(getCheckingValidation,"Testing");
       const SheetName = menuSheet?.sheetName?? "";
      // const SheetName = menuSheet.menuitemlist[0].sheetName;
       console.log("menuSheet",menuSheet);
       
       console.log("SheetName",SheetName);
       console.log("BACKEND RESULT:", JSON.stringify(getCheckingValidation, null, 2));
      
      // getCheckingValidation.map(s=>{
      //   console.log("validated sheetName", s.sheetName);
        
      //   setSheetCategory(s.sheetName);
      // })
      const allSheets = [
        ...getCheckingValidation[0].menuitemlist,
        ...getCheckingValidation[0].testing,
      ]
      setValidatedSheets(allSheets);
      const sheetcategorylist = passedData.excelData[0].menuitemlist.map(s=> s.sheetName);
      console.log("sheetlist",sheetcategorylist);
      
      // setSheetCategory(sheetcategorylist);
      setSheetCategory(allSheets.map(s=>s.sheetName));
      
      
      if (!menuSheet) {
        console.error("MenuItemList sheet not found");
        return;
      }
     console.log("Sending sheets:", JSON.stringify(passedData.excelData, null, 2));
      const rows = menuSheet.rows;
      const testsheetrows = testingSheet?.rows??[];
      console.log('sheetrows',rows);
      console.log('menuSheet',menuSheet);
      console.log('testSheetRows', testsheetrows);
      let ErrorData: any = []
      let ValidData: any = []
      for (const worksheetName of sheetcategorylist){
        if (normalize(worksheetName) === "menuitemlist") {
          rows.map(x => {
        const data = x;
        const errors = x.ErrorList ?? [];
         if (x['ErrorList']?.length > 0){
            ErrorData.push({
              name: 
              // x.rows?.[0].x['name']?.trim()
              data.name?.trim(),
              nativeName: 
              data.nativeName?.trim(),
              // x['nativeName']?.trim(),
              kitchenName:
              data.kitchenName?.trim()
              //  x['kitchenName']?.trim()
               ,
              description: 
              data.description?.trim()
              // x['description']?.trim()
              ,
              major: 
               data.major?.trim()
              // x['major']?.trim()
              ,
              family: 
              data.family?.trim()
              // x['family']?.trim()
              ,
              kitchenPrinter: 
               data.kitchenPrinter?.trim()
              // x['kitchenPrinter']?.trim()
              ,
              taxschemes: 
              data.taxschemes?.trim()
              // x['taxschemes']?.trim()
              ,
              uom:
               data.uom?.trim()
              //  x['uom']?.trim()
              ,
              defaultQuantity: 
              
              parseFloat(
                data?.defaultQuantity
                // x['defaultQuantity']
              )
              ,
              isOpenItem: 
              data.isOpenItem?.trim()
              // x['isOpenItem']?.trim()
              ,
              isOpenPrice: 
              data.isOpenPrice?.trim()
              // x['isOpenPrice']?.trim()
              ,
              isChefRecommended:
              data.isChefRecommended?.trim()
              //  x['isChefRecommended']?.trim()
              ,
              isQuantityControlled: 
              data.isQuantityControlled?.trim()
              // x['isQuantityControlled']?.trim()
              ,
              isDiscountable: 
               data.isDiscountable?.trim()
              // x['isDiscountable']?.trim()
              ,
              isByWeight: 
              data.isByWeight?.trim()
              // x['isByWeight']?.trim()
              ,
              standardCost: 
              parseFloat(data.standardCost)
              // parseFloat(x['standardCost'])
              ,
              isPerforated: 
              data.isPerforated?.trim()
              // x['isPerforated']?.trim()
              ,
              perforatedQuantity:
               parseFloat(data.perforatedQuantity)
              // parseFloat(x['perforatedQuantity'])
              ,
              isDelivery:
              data.isDelivery?.trim()
              ,
              // deliveryPlatform:
              // data.deliveryPlatform?.trim()
              // ,
              isInventory:
              data.isInventory?.trim()
              ,
              stockUom:
              data.stockUom?.trim()
              ,
              isBarCode:
              data.isBarCode?.trim()
              ,
              barcode:
              data.barCode?.trim()
              ,
              isCustomerApp:
              data.isCustomerApp?.trim()
              ,
              ErrorList: errors
              // x['ErrorList']
              ,
            })
          }
        else
          ValidData.push({
             name: 
              // x.rows?.[0].x['name']?.trim()
              data.name?.trim(),
              nativeName: 
              data.nativeName?.trim(),
              // x['nativeName']?.trim(),
              kitchenName:
              data.kitchenName?.trim()
              //  x['kitchenName']?.trim()
               ,
              description: 
              data.description?.trim()
              // x['description']?.trim()
              ,
              major: 
               data.major?.trim()
              // x['major']?.trim()
              ,
              family: 
              data.family?.trim()
              // x['family']?.trim()
              ,
              kitchenPrinter: 
               data.kitchenPrinter?.trim()
              // x['kitchenPrinter']?.trim()
              ,
              taxschemes: 
              data.taxschemes?.trim()
              // x['taxschemes']?.trim()
              ,
              uom:
               data.uom?.trim()
              //  x['uom']?.trim()
              ,
              defaultQuantity: 
              
              parseFloat(
                data?.defaultQuantity
                // x['defaultQuantity']
              )
              ,
              isOpenItem: 
              data.isOpenItem?.trim()
              // x['isOpenItem']?.trim()
              ,
              isOpenPrice: 
              data.isOpenPrice?.trim()
              // x['isOpenPrice']?.trim()
              ,
              isChefRecommended:
              data.isChefRecommended?.trim()
              //  x['isChefRecommended']?.trim()
              ,
              isQuantityControlled: 
              data.isQuantityControlled?.trim()
              // x['isQuantityControlled']?.trim()
              ,
              isDiscountable: 
               data.isDiscountable?.trim()
              // x['isDiscountable']?.trim()
              ,
              isByWeight: 
              data.isByWeight?.trim()
              // x['isByWeight']?.trim()
              ,
              standardCost: 
              parseFloat(data.standardCost)
              // parseFloat(x['standardCost'])
              ,
              isPerforated: 
              data.isPerforated?.trim()
              // x['isPerforated']?.trim()
              ,
              perforatedQuantity:
               parseFloat(data.perforatedQuantity)
              // parseFloat(x['perforatedQuantity'])
              ,
              isDelivery:
              data.isDelivery?.trim()
              ,
              // deliveryPlatform:
              // data.deliveryPlatform?.trim()
              // ,
              isInventory:
              data.isInventory?.trim()
              ,
              stockUom:
              data.stockUom?.trim()
              ,
              isBarCode:
              data.isBarCode?.trim()
              ,
              barcode:
              data.barCode?.trim()
              ,
              isCustomerApp:
              data.isCustomerApp?.trim()
              ,
              ErrorList: errors
              // x['ErrorList']
              ,
            // name: x['name']?.trim(),
            // nativeName: x['nativeName']?.trim(),
            // kitchenName: x['kitchenName']?.trim(),
            // description: x['description']?.trim(),
            // major: x['major']?.trim(),
            // family: x['family']?.trim(),
            // kitchenPrinter: x['kitchenPrinter']?.trim(),
            // taxschemes: x['taxschemes']?.trim(),
            // uom: x['uom']?.trim(),
            // defaultQuantity: Number(x['defaultQuantity']),
            // isOpenItem: x['isOpenItem']?.trim(),
            // isOpenPrice: x['isOpenPrice']?.trim(),
            // isChefRecommended: x['isChefRecommended']?.trim(),
            // isQuantityControlled: x['isQuantityControlled'].trim(),
            // isDiscountable: x['isDiscountable']?.trim(),
            // isByWeight: x['isByWeight']?.trim(),
            // standardCost: Number(x['standardCost']),
            // isPerforated: x['isPerforated']?.trim(),
            // perforatedQuantity:Number(x['perforatedQuantity']),
            // ErrorList: x['ErrorList'],

          })
      });
        }
      }

      // rows.map(x => {
      //   const data = x;
      //   const errors = x.ErrorList ?? [];
      //    if (x['ErrorList']?.length > 0){
      //       ErrorData.push({
      //         name: 
      //         // x.rows?.[0].x['name']?.trim()
      //         data.name?.trim(),
      //         nativeName: 
      //         data.nativeName?.trim(),
      //         // x['nativeName']?.trim(),
      //         kitchenName:
      //         data.kitchenName?.trim()
      //         //  x['kitchenName']?.trim()
      //          ,
      //         description: 
      //         data.description?.trim()
      //         // x['description']?.trim()
      //         ,
      //         major: 
      //          data.major?.trim()
      //         // x['major']?.trim()
      //         ,
      //         family: 
      //         data.family?.trim()
      //         // x['family']?.trim()
      //         ,
      //         kitchenPrinter: 
      //          data.kitchenPrinter?.trim()
      //         // x['kitchenPrinter']?.trim()
      //         ,
      //         taxschemes: 
      //         data.taxschemes?.trim()
      //         // x['taxschemes']?.trim()
      //         ,
      //         uom:
      //          data.uom?.trim()
      //         //  x['uom']?.trim()
      //         ,
      //         defaultQuantity: 
              
      //         parseFloat(
      //           data?.defaultQuantity
      //           // x['defaultQuantity']
      //         )
      //         ,
      //         isOpenItem: 
      //         data.isOpenItem?.trim()
      //         // x['isOpenItem']?.trim()
      //         ,
      //         isOpenPrice: 
      //         data.isOpenPrice?.trim()
      //         // x['isOpenPrice']?.trim()
      //         ,
      //         isChefRecommended:
      //         data.isChefRecommended?.trim()
      //         //  x['isChefRecommended']?.trim()
      //         ,
      //         isQuantityControlled: 
      //         data.isQuantityControlled?.trim()
      //         // x['isQuantityControlled']?.trim()
      //         ,
      //         isDiscountable: 
      //          data.isDiscountable?.trim()
      //         // x['isDiscountable']?.trim()
      //         ,
      //         isByWeight: 
      //         data.isByWeight?.trim()
      //         // x['isByWeight']?.trim()
      //         ,
      //         standardCost: 
      //         parseFloat(data.standardCost)
      //         // parseFloat(x['standardCost'])
      //         ,
      //         isPerforated: 
      //         data.isPerforated?.trim()
      //         // x['isPerforated']?.trim()
      //         ,
      //         perforatedQuantity:
      //          parseFloat(data.perforatedQuantity)
      //         // parseFloat(x['perforatedQuantity'])
      //         ,
      //         ErrorList: errors
      //         // x['ErrorList']
      //         ,
      //       })
      //     }
      //   else
      //     ValidData.push({

      //        name: 
      //         // x.rows?.[0].x['name']?.trim()
      //         data.name?.trim(),
      //         nativeName: 
      //         data.nativeName?.trim(),
      //         // x['nativeName']?.trim(),
      //         kitchenName:
      //         data.kitchenName?.trim()
      //         //  x['kitchenName']?.trim()
      //          ,
      //         description: 
      //         data.description?.trim()
      //         // x['description']?.trim()
      //         ,
      //         major: 
      //          data.major?.trim()
      //         // x['major']?.trim()
      //         ,
      //         family: 
      //         data.family?.trim()
      //         // x['family']?.trim()
      //         ,
      //         kitchenPrinter: 
      //          data.kitchenPrinter?.trim()
      //         // x['kitchenPrinter']?.trim()
      //         ,
      //         taxschemes: 
      //         data.taxschemes?.trim()
      //         // x['taxschemes']?.trim()
      //         ,
      //         uom:
      //          data.uom?.trim()
      //         //  x['uom']?.trim()
      //         ,
      //         defaultQuantity: 
              
      //         parseFloat(
      //           data?.defaultQuantity
      //           // x['defaultQuantity']
      //         )
      //         ,
      //         isOpenItem: 
      //         data.isOpenItem?.trim()
      //         // x['isOpenItem']?.trim()
      //         ,
      //         isOpenPrice: 
      //         data.isOpenPrice?.trim()
      //         // x['isOpenPrice']?.trim()
      //         ,
      //         isChefRecommended:
      //         data.isChefRecommended?.trim()
      //         //  x['isChefRecommended']?.trim()
      //         ,
      //         isQuantityControlled: 
      //         data.isQuantityControlled?.trim()
      //         // x['isQuantityControlled']?.trim()
      //         ,
      //         isDiscountable: 
      //          data.isDiscountable?.trim()
      //         // x['isDiscountable']?.trim()
      //         ,
      //         isByWeight: 
      //         data.isByWeight?.trim()
      //         // x['isByWeight']?.trim()
      //         ,
      //         standardCost: 
      //         parseFloat(data.standardCost)
      //         // parseFloat(x['standardCost'])
      //         ,
      //         isPerforated: 
      //         data.isPerforated?.trim()
      //         // x['isPerforated']?.trim()
      //         ,
      //         perforatedQuantity:
      //          parseFloat(data.perforatedQuantity)
      //         // parseFloat(x['perforatedQuantity'])
      //         ,
      //         ErrorList: errors
      //         // x['ErrorList']
      //         ,
      //       // name: x['name']?.trim(),
      //       // nativeName: x['nativeName']?.trim(),
      //       // kitchenName: x['kitchenName']?.trim(),
      //       // description: x['description']?.trim(),
      //       // major: x['major']?.trim(),
      //       // family: x['family']?.trim(),
      //       // kitchenPrinter: x['kitchenPrinter']?.trim(),
      //       // taxschemes: x['taxschemes']?.trim(),
      //       // uom: x['uom']?.trim(),
      //       // defaultQuantity: Number(x['defaultQuantity']),
      //       // isOpenItem: x['isOpenItem']?.trim(),
      //       // isOpenPrice: x['isOpenPrice']?.trim(),
      //       // isChefRecommended: x['isChefRecommended']?.trim(),
      //       // isQuantityControlled: x['isQuantityControlled'].trim(),
      //       // isDiscountable: x['isDiscountable']?.trim(),
      //       // isByWeight: x['isByWeight']?.trim(),
      //       // standardCost: Number(x['standardCost']),
      //       // isPerforated: x['isPerforated']?.trim(),
      //       // perforatedQuantity:Number(x['perforatedQuantity']),
      //       // ErrorList: x['ErrorList'],

      //     })
      // });
      console.log("validatedData",validatedData);
      
      // setValidatedData({ErrorData,ValidData});
    }
  })
  const [
    createmenuitemwithExcel,
    {
    loading:CreateMenuItemWithExcelloading,
    data: CreateMenuItemWithExcel
    }
  ]= useCreateMenuItemWithExcelMutation({
    // fetchPolicy: 'network-only',
      // variables: {
      //   MenuItemImportInput: passedData.excelData,
      //   outletID: outletID
      // },
        onCompleted: () => {
        // let ErrorData: any = []
        // let ValidData: any = []
        console.log("CreateMenuItemWithExcel",CreateMenuItemWithExcel);
        setSnackBarMsg(SystemMsgs.createNewRecord());

      
          history.push({
             pathname: `/menu/outlet-app/outlet-setting/${outletID}/menu-item`,
            state:{success:true,msgMode:'create'}
          })
        // getCheckingValidationMenuItem?.map(x => {
        //   if (x['ErrorList']?.length > 0)
        //     ErrorData.push({
        //       name: x['name'],
        //       nativeName: x['nativeName'],
        //       kitchenName: x['kitchenName'],
        //       description: x['description'],
        //       uomID: x['uomID'],
        //       defaultQuantity: Number(x['defaultQuantity']),
        //       isOpenItem: x['isOpenItem'],
        //       isOpenPrice: x['isOpenPrice'],
        //       isChefRecommended: x['isChefRecommended'],
        //       isQuantityControlled: x['isQuantityControlled'],
        //       isDiscountable: x['isDiscountable'],
        //       isByWeight: x['isByWeight'],
        //       standardCost: Number(x['standardCost']),
        //       isPerforated: x['isPerforated'],
        //       perforatedQuantity:Number(x['perforatedQuantity']),
        //       ErrorList: x['ErrorList'],
        //     })
        //   else
        //     ValidData.push({
        //       name: x['name'],
        //       nativeName: x['nativeName'],
        //       kitchenName: x['kitchenName'],
        //       description: x['description'],
        //       uomID: x['uomID'],
        //       defaultQuantity: Number(x['defaultQuantity']),
        //       isOpenItem: x['isOpenItem'],
        //       isOpenPrice: x['isOpenPrice'],
        //       isChefRecommended: x['isChefRecommended'],
        //       isQuantityControlled: x['isQuantityControlled'],
        //       isDiscountable: x['isDiscountable'],
        //       isByWeight: x['isByWeight'],
        //       standardCost: Number(x['standardCost']),
        //       isPerforated: x['isPerforated'],
        //       perforatedQuantity:Number(x['perforatedQuantity']),
        //       ErrorList: x['ErrorList'],
        //     })
        // })

        // setValidatedData({ ErrorData: ErrorData, ValidData: ValidData })
      },
  })


  	const handleChange = (event,newValue) => {
    setSelectedTab(newValue);
	};
//   const [
//     createCompanyImport,
//     { loading: createCompanyLoading, error: createCompanyImportError },
//   ] = useCreateCompanyImportMutation({
//     onError: error => {
//       console.log('ERROR', error)
//     },
//     onCompleted: data => {
//       setOpenSnackBar(true)
//       setSnackBarMsg(SystemMsgs.createNewRecord())
//       history.push({
//         pathname: `/company-setup`,
//         state: {
//           success: true,
//           msgMode: 'create',
//         },
//       })
//     },
//   })

  const {
    openFileUpload,
    setOpenFileUpload,
    fileTitle,
    setFileTitle,
    openSnackBar,
    //setOpenSnackBar,
    snackBarMessage,
    setSnackBarMessage,
    currentData,
    setCurrentData,
    onDownloadTemplate,
    onSelectFile,
    duplicateItems,
    errorDialog: duplicateErrorDia,
    setErrorDialog,
    resetFileUpload,
  } = useExcelUploadVersion2()

  // const createCompanyExcel = data => {
  //   let stringifyData = JSON.stringify(data)

  //   // createCompanyImport({
  //   //   variables: {
  //   //     TemplateStr: stringifyData,
  //   //   },
  //   // })
  // }

  const createMenuItemExcel = data =>{
     let stringifyData = JSON.stringify(data)

     createMenuItemExcel({
        variables: {
          TemplateStr: stringifyData,
        },
     });
  }

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <>
      {/* {checkingValidationCompanyLoading && <Loading />}
      {createCompanyLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => history.push(`/company-setup`)}
        smTitle={'Company Setup'}
        title={user?.accountName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Company Setup', current: true },
        ]}
      /> */}
        <MainHeader
            onClick={() => {
                // localStorage.setItem(
                //     `searchFilter`,
                //     JSON.stringify({
                //         outletList: menuItemSearch?.outletList ?? '',
                //         outletSubmenu: menuItemSearch?.outletSubmenu ?? '',
                //         menuItemSearch: '',
                //     }),
                // );
                history.push({
                    pathname: `/menu/outlet-app/outlet-setting/${outletID}/menu-item`,
                });
            }}
            mainBtn="close"
            smTitle={`Outlet App`}
            title={outletArray[0]?.name}
            // title={outletArray[0]?.name}
            routeSegments={[
                { name: 'Outlet Settings' },
                { name: 'Menu Items', current: true },
            ]}
        />
      <DynamicSubHeader
        style={{
          marginTop: '-2px',
        }}
        title={'Menu Items Excel Upload'}
        rightText={<span className="c-orange">Validation</span>}
      />
      <List className="search-header fixed-search-header with-dynamic">
        <ListItem>
          <ListItemText
            primary={
              <>
                <span className="xsTitle flex-space">{fileName}</span>
              </>
            }
          />
        </ListItem>
      </List>
           <div
				className="core-tab"
				style={{
					position: 'fixed',
					padding: '0px',
					width:
						isDesktop && globalState.drawerOpen
							? 'inherit'
							: '-webkit-fill-available',
				}}
			>
      <AppBar position="static">
        <Tabs
          aria-label="simple tabs example"
          indicatorColor="primary"
          textColor="primary"
          value={selectedTab}
          onChange={handleChange}
          variant={'scrollable'}
        >
          {/* {getOutletDailyMenuCategory
            .sort((a, b) => Number(a.priority) - Number(b.priority))
            ?.map((x, index) => (
              <Tab label={x?.name} {...a11yProps(index)} />
            ))} */}
            {/* {sheetCategory.map((x)=>{
              <Tab label={x?.sheet}  />
            })} */}
            {sheetCategory?.map((sheet,index)=>(
                <Tab key={index} label={sheet}/>
            ))}
        </Tabs>
      </AppBar>

      </div>
      <ContentWrapper
        style={{ marginTop: isDesktop ? '149px' : '87px' }}
        float
        footer
      >

        {sheetCategory.map((s,index)=>{
        if(index !== selectedTab){
            return null;
          }
          const normalize = name => name?.toLowerCase().replace(/\s+/g, "").trim();

          console.log("normalize result = ",normalize(s));
           console.log("MenuItemList sheet",normalize(s) === "menuitemlist");
        
          
          if (normalize(s) === "menuitemlist") {
            console.log("Rendering Menuitemlist tab true");
            
            return (
              <>
              {/* Problem List */}
              {validatedData.ErrorData?.length > 0 && (
                <>
                  <List style={{ marginBottom: '-13px' }}>
                    <ListItem>
                      <ListItemText
                        primary={
                          <>
                            <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                              Problem{' '}
                              {
                                <>
                                  (
                                  <span className="highlight-text">
                                    {validatedData.ErrorData?.length}
                                  </span>
                                  )
                                </>
                              }
                            </span>
                          </>
                        }
                      />
                    </ListItem>
                  </List>
                  <List className="core-list">
                    {validatedData.ErrorData?.map((el, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          // style={{
                          //   textAlign: 'right',
                          //   marginLeft: '5px',
                          // }}
                          primary={
                            <>
                              <div style={{ width: '100%' }}>

                                <div>
                                  <span className="desc">name: {el.name}</span>
                                </div>

                                <div>
                                  <span className="desc">
                                    nativeName: {el.nativeName}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">kitchenName: {el.kitchenName}</span>
                                </div>
                                <div>
                                  <span className="desc">description: {el.description}</span>
                                </div>
                                <div>
                                  <span className="desc">major: {el.major}</span>
                                </div>
                                <div>
                                  <span className="desc">family: {el.family}</span>
                                </div>
                                <div>
                                  <span className="desc">kitchenPrinter: {el.kitchenPrinter}</span>
                                </div>
                                <div>
                                  <span className="desc">taxschemes: {el.taxschemes}</span>
                                </div>
                                <div>
                                  <span className="desc">
                                    {/* {el.Address}, {el.PostCode}, {el.City}, {el.State}
                                    , {el.Country} */}
                                    uom: {el.uom}
                                  </span>
                                </div>
                                
                                
                                <div>
                                  <span className="desc">
                                    {/* {el.Address}, {el.PostCode}, {el.City}, {el.State}
                                    , {el.Country} */}
                                    defaultQuantity: {el.defaultQuantity}
                                  </span>
                                </div>
                                
                                <div>
                                  <span className="desc">
                                    {/* {el.Address}, {el.PostCode}, {el.City}, {el.State}
                                    , {el.Country} */}
                                    isOpenItem: {el.isOpenItem }
                                  </span>
                                </div>
                                
                                <div>
                                  <span className="desc">
                                    {/* {el.Address}, {el.PostCode}, {el.City}, {el.State}
                                    , {el.Country} */}
                                    isOpenPrice: {el.isOpenPrice}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    {/* {el.Address}, {el.PostCode}, {el.City}, {el.State}
                                    , {el.Country} */}
                                    isChefRecommended: {el.isChefRecommended }
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    {/* {el.Address}, {el.PostCode}, {el.City}, {el.State}
                                    , {el.Country} */}
                                    isQuantityControlled: {el.isQuantityControlled }
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    {/* {el.Address}, {el.PostCode}, {el.City}, {el.State}
                                    , {el.Country} */}
                                    isDiscountable: {el.isDiscountable}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    {/* {el.Address}, {el.PostCode}, {el.City}, {el.State}
                                    , {el.Country} */}
                                    isByWeight: {el.isByWeight}
                                  </span>
                                </div>

                                <div>
                                  <span className="desc">
                                    {/* {el.Address}, {el.PostCode}, {el.City}, {el.State}
                                    , {el.Country} */}
                                    standardCost: {el.standardCost}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    {/* {el.Address}, {el.PostCode}, {el.City}, {el.State}
                                    , {el.Country} */}
                                    isPerforated: {el.isPerforated}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    {/* {el.Address}, {el.PostCode}, {el.City}, {el.State}
                                    , {el.Country} */}
                                    perforatedQuantity: {el.perforatedQuantity}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    isDelivery: {el.isDelivery}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    isInventory: {el.isInventory}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    stockUom: {el.stockUom}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    isBarCode: {el.isBarCode}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    barCode: {el.barCode}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    isCustomerApp: {el.isCustomerApp}
                                  </span>
                                </div>
                                {/* {el?.Status === 'Active' && (
                                  <div
                                    className="blue-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Active
                                  </div>
                                )}
                                {el?.Status === 'Inactive' && (
                                  <div
                                    className="grey-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Inactive
                                  </div>
                                )} */}
                              </div>
                            </>
                          }
                          
                          secondary={
                            <>
                              <div>
                                {/* <div
                                  className="xsTitle text-noflow"
                                  style={{ color: 'red' }}
                                >
                                  {' '}
                                  DefaultQuantity: {el.defaultQuantity}
                                </div> */}
                                <div
                                  className="xsTitle text-noflow"
                                  style={{ color: 'red' }}
                                >
                                  {' '}
                                  {el.ErrorList?.map((x, index) => {
                                    if (index == el.ErrorList?.length - 1)
                                      return `${x}`
                                    else return `${x}, `
                                  })}
                                </div>
                              </div>
                            </>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </>
              )}

              {/* Validation List */}
              {validatedData.ValidData?.length > 0 && (
                <>
                  <List style={{ marginBottom: '-13px' }}>
                    <ListItem>
                      <ListItemText
                        primary={
                          <>
                            <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                              Validated{' '}
                              {
                                <>
                                  (
                                  <span className="highlight-text">
                                    {validatedData.ValidData?.length}
                                  </span>
                                  )
                                </>
                              }
                            </span>
                          </>
                        }
                      />
                    </ListItem>
                  </List>
                  <List className="core-list">
                    {validatedData.ValidData?.map((el, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          // style={{
                          //   textAlign: 'right',
                          //   marginLeft: '5px',
                          // }}
                          
                          primary={
                            <>
                              <div style={{ width: '100%' }}>
                                <div>
                                  <span className="xsTitle flex-space ">
                                    name: {el.name}{' '}
                                  </span>
                                </div>

                                <div>
                                  <span className="desc">nativeName: {el.nativeName}</span>
                                </div>

                                <div>
                                  <span className="desc">
                                      kitchen Name: {el.kitchenName}
                                  </span>
                                </div>

                                <div>
                                  <span className="desc">description: {el.description}</span>
                                </div>

                                <div>
                                  <span className="desc">major: {el.major}</span>
                                </div>

                                <div>
                                  <span className="desc">family: {el.family}</span>
                                </div>

                                <div>
                                  <span className="desc">kitchenPrinter: {el.kitchenPrinter}</span>
                                </div>

                                <div>
                                  <span className="desc">taxSchemes: {el.taxschemes}</span>
                                </div>

                                <div>
                                  <span className="desc">
                                    uom: {el.uom}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    defaultQuantity: {el.defaultQuantity}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    isOpenItem: {el.isOpenItem}
                                  </span>
                                </div>

                                <div>
                                  <span className="desc">
                                    isOpenPrice: {el.isOpenPrice}
                                  </span>
                                </div>

                                <div>
                                  <span className="desc">
                                    isChefRecommended: {el.isChefRecommended}
                                  </span>
                                </div>

                                <div>
                                  <span className="desc">
                                    isQuantityControlled: {el.isQuantityControlled}
                                  </span>
                                </div>

                                <div>
                                  <span className="desc">
                                    isDiscountable: {el.isDiscountable}
                                  </span>
                                </div>

                                <div>
                                  <span className="desc">
                                    isByWeight: {el.isByWeight}
                                  </span>
                                </div>
                                
                                <div>
                                  <span className="desc">
                                    standardCost: {el.standardCost}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    isPerforated: {el.isPerforated}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    isDelivery: {el.isDelivery}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    isInventory: {el.isInventory}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    stockUom: {el.stockUom}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    isBarCode: {el.isBarCode}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    barCode: {el.barCode}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    isCustomerApp: {el.isCustomerApp}
                                  </span>
                                </div>
                                <div>
                                  <span className="desc">
                                    {' '}
                                    {el.ErrorList?.map((x, index) => {
                                          if (index == el.ErrorList?.length - 1)
                                              return `${x}`
                                          else return `${x}, `
                                      })}
                                  </span>
                                </div>
                                {/* {el?.Status === 'Active' && (
                                  <div
                                    className="blue-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Active
                                  </div>
                                )}
                                {el?.Status === 'Inactive' && (
                                  <div
                                    className="grey-status"
                                    style={{
                                      padding: '5px',
                                      margin: '0px',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    Inactive
                                  </div>
                                )} */}
                              </div>
                            </>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </>
              )}
              </>
            );
           }
          return null;
        })}
      </ContentWrapper>

      <ExcelInput
        showFooter={false}
        showDupErrors={true}
        duplicateItems={duplicateItems}
        errorDia={duplicateErrorDia}
        setErrorDia={setErrorDialog}
        openUpload={openFileUpload}
        setOpenUpload={setOpenFileUpload}
        upload={fileTitle}
        template={currentData}
        setTemplate={setCurrentData}
        setUpload={setFileTitle}
        resetFileUpload={resetFileUpload}
        onUploadTemplate={async () => {
				const normalize = name => name?.toLowerCase().replace(/\s+/g, "").trim();
        const exceldata = [
          {
            menuitemlist:[],
            testing:[]
          }
        ];
        const validated = {ErrorData:[],ValidData:[]};

        // keep old erros if re-uploading
        const previousValidated = passedData?.validatedData ?? {ErrorData:[],ValidData:[]};
        const sheetvalidation = (sheetName,mapping)=>{
          const sheet = currentData.find(
            s=>normalize(s.sheetName) === normalize(sheetName));
          if (!sheet) {
            console.warn(`Sheet ${sheet} not found`);
            return null;
          }
          // exceldata[0][key]=[
          //  { sheetName:sheetName,
          //   rows:sheet.rows.map(mapping)}
          // ];

          exceldata[0].menuitemlist.push({
            sheetName:sheetName,
            rows:sheet.rows.map(mapping)
          })

          // return mappedRows;// return to validate locally
        };

        const menuRows = sheetvalidation("MenuItemList", x=>{

          const oldError = previousValidated.ErrorData.find(r=>r.name ===x.name)?.ErrorList||[];
          return {
             name:
                  x?.name === null ? null : `${x?.name?.trim()}`,
                nativeName:
                  x?.nativeName === null ? null : `${x?.nativeName?.trim()}`,
                kitchenName:
                  x?.kitchenName === null ? null : `${x?.kitchenName?.trim()}`,
                description:
                  x?.description === null ? null : `${x?.description?.trim()}`,
                major:
                  x?.major === null ? null : `${x?.major?.trim()}`,
                family:
                  x?.family === null ? null : `${x?.family?.trim()}`,
                kitchenPrinter:
                  x?.kitchenPrinter === null ? null : `${x?.kitchenPrinter?.trim()}`,
                taxschemes:
                  x?.taxschemes === null ? null : `${x?.taxschemes?.trim()}`,
                uom: x?.uom === null ? null : `${x?.uom?.trim()}`,
                defaultQuantity: x?.defaultQuantity === null ? null : Number(`${x?.defaultQuantity}`),
                isOpenItem:x?.isOpenItem=== null?null:`${x?.isOpenItem}`,
                isOpenPrice:x?.isOpenPrice === null?null:`${x?.isOpenPrice}`,
                isChefRecommended: x?.isChefRecommended === null?null:`${x?.isChefRecommended}`,
                isQuantityControlled: x?.isQuantityControlled === null?null:`${ x?.isQuantityControlled}`,
                isDiscountable: x?.isDiscountable ===null?null:`${x?.isDiscountable}` ,
                isByWeight:x?.isByWeight === null?null:`${x?.isByWeight}` ,
                standardCost: x?.standardCost === null ? null : Number(`${x?.standardCost}`),
                isPerforated:x?.isPerforated === null?null:`${x?.isPerforated}`,
                perforatedQuantity: x?.perforatedQuantity === null ? null : Number(`${x?.perforatedQuantity}`),
                isDelivery: x?.isDelivery=== null?null:`${x?.isDelivery}`,
                // deliveryPlatform: x?.deliveryPlatform === null? null:`${x?.deliveryPlatform}`,
                isInventory:x?.isInventory === null?null:`${x?.isInventory}`,
                stockUom:x?.stockUom === null?null: `${x?.stockUom}`,
                isBarCode:x?.isBarCode === null?null:`${x?.isBarCode}`,
                barCode:x?.barCode === null?null:`${x?.barCode}`,
                isCustomerApp:x?.isCustomerApp === null?null:`${x?.isCustomerApp}`,
                // Status: x?.Status === null ? null : `${x?.Status}`,
                // ErrorList: x?.ErrorList,
                ErrorList: Array.isArray(x?.ErrorList)?x.ErrorList:oldError,
          }
         
        });

        const testRows = 
        sheetvalidation("Testing",x=>{
          const oldError = previousValidated.ErrorData.find(r=>r.name ===x.name)?.ErrorList||[];
        return{					
          testingname: x?.testingname === null ? null:`${x?.testingname?.trim()}`,
					testingemail: x?.testingemail=== null? null:`${x?.testingemail?.trim()}`,
          ErrorList: Array.isArray(x?.ErrorList)?x.ErrorList:oldError,}
          
				});
        
        if (menuRows) {
          menuRows.map(row =>{
            console.log("menuRowserrorlist",row.ErrorList);            
            if (row.ErrorList?.length>0) {
              validated.ErrorData.push(row);
            }else{
              validated.ValidData.push(row);
            }
          })
        }
        
        // if (testRows) {
        //   testRows.map(row=>{
        //     console.log('TestingRowarrorlist',row.ErrorList);
        //     if (row.ErrorList?.length>0) {
        //       validated.ErrorData.push(row)
        //     }else{
        //       validated.ValidData.push(row)
        //     }
        //   })
        // }

        setValidatedData(validated);
        console.log("exceldata",exceldata,"currentdata",currentData,"validated",validated);
      
          history.push({
            pathname: setOpenFileUpload? `/menu/outlet-app/outlet-setting/${outletID}/menu-item/excel-validation`:`/menu/outlet-app/outlet-setting/${outletID}/menu-item`,
            state: {
              excelData: exceldata
            //   [
            //     {
            //     sheetName: "MenuItemList",
            //     rows: currentData?.map(x => {
            //     console.log("isPerforated",x);
            //     return {
            //       name:
            //         x?.name === null ? null : `${x?.name?.trim()}`,
            //       nativeName:
            //         x?.nativeName === null ? null : `${x?.nativeName?.trim()}`,
            //       kitchenName:
            //         x?.kitchenName === null ? null : `${x?.kitchenName?.trim()}`,
            //       description:
            //         x?.description === null ? null : `${x?.description?.trim()}`,
            //       major:
            //         x?.major === null ? null : `${x?.major?.trim()}`,
            //       family:
            //         x?.family === null ? null : `${x?.family?.trim()}`,
            //       kitchenPrinter:
            //         x?.kitchenPrinter === null ? null : `${x?.kitchenPrinter?.trim()}`,
            //       taxschemes:
            //         x?.taxschemes === null ? null : `${x?.taxschemes?.trim()}`,
            //       uom: x?.uom === null ? null : `${x?.uom?.trim()}`,
            //       defaultQuantity: x?.defaultQuantity === null ? null : Number(`${x?.defaultQuantity}`),
            //       isOpenItem:String(x?.isOpenItem).trim(),
            //       isOpenPrice: String(x?.isOpenPrice).trim(),
            //       isChefRecommended: String(x?.isChefRecommended).trim(),
            //       isQuantityControlled: String(x?.isQuantityControlled).trim(),
            //       isDiscountable: String(x?.isDiscountable).trim() ,
            //       isByWeight: String(x?.isByWeight).trim() ,
            //       standardCost: x?.standardCost === null ? null : Number(`${x?.standardCost}`),
            //       isPerforated: String(x?.isPerforated).trim(),
            //       perforatedQuantity: x?.perforatedQuantity === null ? null : Number(`${x?.perforatedQuantity}`),
            //       // Status: x?.Status === null ? null : `${x?.Status}`,
            //       ErrorList: x?.ErrorList,
            //     }
            //   }
            // )
            //   }
            // ]
            ,
            validatedData:validated,
            //   currentData?.map(x => {
            //     console.log("isPerforated",x);
            //     return {
            //       name:
            //         x?.name === null ? null : `${x?.name?.trim()}`,
            //       nativeName:
            //         x?.nativeName === null ? null : `${x?.nativeName?.trim()}`,
            //       kitchenName:
            //         x?.kitchenName === null ? null : `${x?.kitchenName?.trim()}`,
            //       description:
            //         x?.description === null ? null : `${x?.description?.trim()}`,
            //       major:
            //         x?.major === null ? null : `${x?.major?.trim()}`,
            //       family:
            //         x?.family === null ? null : `${x?.family?.trim()}`,
            //       kitchenPrinter:
            //         x?.kitchenPrinter === null ? null : `${x?.kitchenPrinter?.trim()}`,
            //       taxschemes:
            //         x?.taxschemes === null ? null : `${x?.taxschemes?.trim()}`,
            //       uom: x?.uom === null ? null : `${x?.uom?.trim()}`,
            //       defaultQuantity: x?.defaultQuantity === null ? null : Number(`${x?.defaultQuantity}`),
            //       isOpenItem:String(x?.isOpenItem).trim(),
            //       isOpenPrice: String(x?.isOpenPrice).trim(),
            //       isChefRecommended: String(x?.isChefRecommended).trim(),
            //       isQuantityControlled: String(x?.isQuantityControlled).trim(),
            //       isDiscountable: String(x?.isDiscountable).trim() ,
            //       isByWeight: String(x?.isByWeight).trim() ,
            //       standardCost: x?.standardCost === null ? null : Number(`${x?.standardCost}`),
            //       isPerforated: String(x?.isPerforated).trim(),
            //       perforatedQuantity: x?.perforatedQuantity === null ? null : Number(`${x?.perforatedQuantity}`),
            //       // Status: x?.Status === null ? null : `${x?.Status}`,
            //       ErrorList: x?.ErrorList,
            //     }
            //   }
            // ),
              fileTitle: fileTitle,
            },
          })
            setOpenFileUpload(false)
            resetFileUpload()
            setFileTitle('')
          
         
        }}
        onSelectFile={(e: any) => {
          onSelectFile({ event: e })
        }}
        onDownloadTemplate={() => {}}
        snackBarProps={{
          openSnackBar: openSnackBar,
          snackBarMessage: snackBarMessage,
          setOpenSnackBar: setOpenSnackBar,
          onClickButton: () => {
            setOpenSnackBar(false)
          },
        }}
      />
      <Footer
        options={
          validatedData.ErrorData?.length === 0 &&
          validatedData.ValidData?.length > 0
            ? [
                {
                  onClick: () => {
                    setOpenDialog(true)
                  },
                  name: 'Confirm Upload',
                  color: 'primary',
                },
              ]
            : [
                {
                  name: 'Re-upload',
                  color: 'primary',
                  onClick: () => {
                    setOpenFileUpload(true)
                  },
                },
              ]
        }
      />

      <CommonDialog
        fullWidth={true}
        open={openDialog}
        onClose={() => {
          setOpenDialog(false)
        }}
        sections={{
          header: {
            dynamic: (
              <div className="">
                <div className="dialog-dynamic-content">
                  <span
                    className="title c-orange flex-space"
                    style={{
                      fontSize: '13px',
                      fontWeight: 'bold',
                    }}
                  >
                    Upload Confirmation
                  </span>
                </div>
              </div>
            ),
          },
          body: () => (
            <div>
              <span>{'Are you sure to upload?'}</span>
            </div>
          ),

          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    setOpenDialog(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                      // createMenuItemExcel(useGetCheckingValidationMenuItemQuery);
                    // createCompanyExcel(getCheckingValidationCompany)
                    const menuItems = passedData?.excelData[0].menuitemlist[0].rows.map(
                      ({sheetName,ErrorList,...menuItem})=> menuItem
                    );
                    console.log('menuItems:',menuItems);
                    
                    createmenuitemwithExcel({
                     variables: {
                      MenuItemImportInput: menuItems,
                      outletID: outletID
                    },
                    })
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <CommonDialog
        fullWidth={true}
        open={errorNumberingStructure}
        onClose={() => {
          setErrorNumberingStructure(false)
        }}
        sections={{
          header: {
            dynamic: (
              // <div className="">
              //   <div className="dialog-dynamic-content">
              //     <span
              //       className="title c-orange flex-space"
              //       style={{
              //         fontSize: '13px',
              //         fontWeight: 'bold',
              //       }}
              //     >
              //       Error!
              //     </span>
              //   </div>
              // </div>

              <>
                <span className="xsTitle flex-space" style={{ color: 'red' }}>
                  Error!
                </span>
              </>
            ),
          },
          body: () => (
            <div>
              <span>
                {'Document Numbering for External Journal is not created.'}
              </span>
            </div>
          ),

          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => {
                    setErrorNumberingStructure(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
    </>
  )
}
